export default {"src":"/_next/static/media/karryNow.129c2b46.svg","height":36,"width":147};